import l, { useCallback as h } from "react";
import { useTheme as v, Text as S } from "@chakra-ui/react";
import "react-icons/md";
import "./button.js";
import { IconButton as k } from "./icon-button.js";
import "react-icons/fa";
import "@loadable/component";
import "./masthead-button.js";
import "@chakra-ui/system";
import "framer-motion";
import "react-icons/fi";
import "react-icons/hi";
import "react-icons/ri";
import { IoTrashOutline as y } from "react-icons/io5";
import "./close-button.js";
const q = ({
  ariaLabel: a,
  onRemoveFromList: m,
  removeFromListCta: { text: p, url: o },
  productItemId: e
}) => {
  const {
    background: { default: i },
    button: { utilityBorderRadiusSm: s },
    element: { spacingSmall: u },
    interactive: { backgroundDefault: b, pressed: r, default: t },
    shoppingListItemRemoveIcon: n,
    shoppingListItemSubcopy: d
  } = v(), f = h(async () => {
    m(o, e);
  }, [o, e]), c = {
    bg: b,
    iconFill: r,
    color: r
  }, g = {
    bg: i,
    iconFill: t,
    color: t
  };
  return /* @__PURE__ */ l.createElement(
    k,
    {
      role: "button",
      "aria-label": a,
      icon: y,
      iconFill: t,
      iconWidth: n,
      iconHeight: n,
      bg: i,
      p: u,
      borderRadius: s,
      _hover: c,
      _focus: g,
      _active: c,
      onClick: f
    },
    /* @__PURE__ */ l.createElement(S, { color: t, ...d }, p)
  );
};
export {
  q as RemoveButton
};
